import React from 'react';
import SafeIcon from '../common/SafeIcon';
import AudioPlayer from './AudioPlayer';

const Hero = () => {
  return (
    <section className="pt-32 pb-12 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto text-center">
      <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-slate-800/50 border border-slate-700 mb-8">
        <span className="flex h-2 w-2 rounded-full bg-emerald-400 animate-pulse"></span>
        <span className="text-sm font-medium text-slate-300">
          <strong className="text-white">3-Day Free Trial</strong> • Instant 10-Second Setup Text-Back • Zero Risk
        </span>
      </div>

      <h1 className="text-5xl md:text-7xl font-extrabold text-white tracking-tight mb-6 leading-tight">
        Stop the Revenue Bleed:
        <br />
        <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-emerald-400">
          Every Missed Call Goes Directly to Your Competitors
        </span>
      </h1>

      <p className="max-w-3xl mx-auto text-lg md:text-xl text-slate-400 mb-8 leading-relaxed">
        Local service businesses miss up to 62% of incoming phone calls. AutoReception answers every call instantly 24/7, qualifies leads, schedules appointments, and sends automated text-backs within 10 seconds.
      </p>

      <a
        href="tel:+12185100200"
        className="inline-flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-3 mb-10 px-6 py-4 rounded-2xl bg-emerald-500/10 border border-emerald-400/40 hover:bg-emerald-500/20 transition-all shadow-[0_0_25px_rgba(16,185,129,0.12)]"
        aria-label="Call AutoReception at plus one two one eight five one zero zero two zero zero"
      >
        <span className="flex items-center gap-2 text-emerald-300 font-semibold">
          <SafeIcon name="PhoneCall" className="text-xl" />
          Call the AutoReception now
        </span>
        <span className="text-xl sm:text-2xl font-extrabold tracking-wide text-white">
          +1 (218) 510-0200
        </span>
      </a>

      <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12">
        <a
          href="#contact"
          className="w-full sm:w-auto bg-blue-600 hover:bg-blue-500 text-white px-8 py-4 rounded-full font-bold text-lg transition-all shadow-[0_0_20px_rgba(37,99,235,0.5)] flex items-center justify-center gap-2"
        >
          Start 3-Day Free Trial
          <SafeIcon name="ArrowRight" />
        </a>

        <a
          href="#calculator"
          className="w-full sm:w-auto bg-slate-800 hover:bg-slate-700 text-white px-8 py-4 rounded-full font-bold text-lg transition-all border border-slate-700 flex items-center justify-center gap-2"
        >
          Calculate Lost Revenue
          <SafeIcon name="Calculator" />
        </a>
      </div>

      <AudioPlayer />
    </section>
  );
};

export default Hero;